module.exports = __webpack_public_path__ + "fewww/img/avatar.38f6ec41.png";